import React from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Dropdown from 'react-bootstrap/Dropdown';
import ClientHeadMenu from './ClientHeadMenu';
import { deleteClient } from '../ducks/clientProfileActions';

class ClientHead extends React.Component {
  render() {
    const isProgressTAb = window.location.pathname.endsWith('/progress-photos');
    let disabled = !this.props.isActive ? {disabled: true} : {};
    return (
      <div className="client-profile-head">
        <div className="shape shape-left"></div>
        <div className="shape shape-right"></div>
        <div className="container head-container">
          <Breadcrumb className="top-header">
            <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
            {isProgressTAb && (
              <Breadcrumb.Item href={`/clients/${this.props.clientId}`}>
                {this.props.userName}
              </Breadcrumb.Item>
            )}
            <Breadcrumb.Item active>
              {isProgressTAb ? 'Progress Photos' : this.props.userName}
            </Breadcrumb.Item>
          </Breadcrumb>
          <div className="page-actions">
            <Link to={`/messages?client=${this.props.clientId}`}>
              <i className="fas fa-comments"></i>
            </Link>
            <Dropdown>
              <Dropdown.Toggle>
                <i className="fas fa-ellipsis-h"></i>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                <Dropdown.Item href={`/clients/${this.props.clientId}/onboardingQuestions`} {...disabled}>
                  onboarding questions
                </Dropdown.Item>

                <Dropdown.Item href={`/clients/${this.props.clientId}/questionnaire`} {...disabled}>
                  kickstart questionnaire
                </Dropdown.Item>
                <Dropdown.Item
                  onClick={() => {
                    this.props.deleteClient(
                      this.props.clientId,
                      this.props.history
                    );
                  }}
                >
                  Delete Client
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
            <ClientHeadMenu clientId={this.props.clientId} />
          </div>
        </div>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    deleteClient: (id, history) => dispatch(deleteClient(id, history))
  };
}

export default connect(null, mapDispatchToProps)(ClientHead);
